<script lang="ts" setup>
  /**
   * @file Icon.vue
   * @description 图标组件，基于 Iconfont Symbol 方式封装
   */
  import { computed } from 'vue'
  import { cn } from '../../../lib/utils'

  const props = withDefaults(
    defineProps<{
      /** 图标名称（对应 Iconfont 的 Symbol ID，无需 #） */
      icon?: string
      /** 自定义类名 */
      class?: any
    }>(),
    {
      icon: '',
      class: '',
    },
  )

  /**
   * 计算完整的 Symbol ID
   * @returns {string} 带 # 前缀的 ID
   */
  const symbolId = computed(() => `#ahub-${props.icon}`)
</script>

<template>
  <svg :class="cn('icon', props.class)" aria-hidden="true">
    <use :xlink:href="symbolId"></use>
  </svg>
</template>

<style scoped>
  .icon {
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
  }
</style>
